module.exports = __webpack_public_path__ + "img/click.1ce3d23c.png";